import { render, staticRenderFns } from "./LogStatistics.vue?vue&type=template&id=fb70cb7a"
import script from "./LogStatistics.vue?vue&type=script&lang=js"
export * from "./LogStatistics.vue?vue&type=script&lang=js"
import style0 from "./LogStatistics.vue?vue&type=style&index=0&id=fb70cb7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports